import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	discardTitle: {
		id: 'eoc-schedule.ui.list.discard-changes.discard-title',
		defaultMessage: 'Discard changes?',
		description: 'Title for discard changes modal.',
	},
	discardDescription: {
		id: 'eoc-schedule.ui.list.discard-changes.discard-description',
		defaultMessage: 'Rotation <bold>{rotationName}</bold> will continue to work as it is.',
		description: 'Explanation for what discarding edit rotation does.',
	},
	discardCloseTitle: {
		id: 'eoc-schedule.ui.list.discard-changes.discard-close-title',
		defaultMessage: 'You have unsaved changes',
		description: 'Title for discard and close changes modal.',
	},
	discardCloseDescription: {
		id: 'eoc-schedule.ui.list.discard-changes.discard-close-description',
		defaultMessage:
			"You've made some changes on rotation <bold>{rotationName}</bold> but didn't update. Closing the schedule will discard changes and rotation <bold>{rotationName}</bold> will continue to work as it is.",
		description: 'Explanation for what discarding and closing edit rotation does.',
	},
	discardClose: {
		id: 'eoc-schedule.ui.list.discard-changes.discard-close',
		defaultMessage: 'Discard and close',
		description: 'Button for discarding and closing edit mode.',
	},
});

export { messages };
